import React, {useEffect, useState} from 'react';
import { Col } from 'antd';
import CustomerBaseBidCard from './CustomerBaseBidCard';
import CustomerBaseChartContainer from './CustomerBaseChartContainer';

const CustomerBaseDisplayCards = ({data}) => {
    const [clustredData, setClustredData] = useState({});

    useEffect(() => {
        organizeData();
    }, [data]);
    
    const hasCardData = () => {
        return data.some((dto) => dto.hasOwnProperty('customerBidDTOS') && dto.customerBidDTOS.length);
    }

    const organizeData = () => {
        //currency clustered data
        const availableCurrencies = {
            "EUR": [],
            "USD": [],
            "TRY": []
        };

        data.forEach((bids) => {
            const bidStatus = bids.bidStatus;

            if(bids.customerBidDTOS.length) {
                bids.customerBidDTOS.forEach((dto) => {
                    if(dto.hasOwnProperty('cr') && availableCurrencies.hasOwnProperty(dto.cr)) {
                        availableCurrencies[(dto.cr).toUpperCase()].push({
                            bidStatus: bidStatus,
                            count: dto.c,
                            priceWithTax: dto.pit,
                            priceWithoutTax: dto.pet    
                        })
                    }
                })
            }
        })

        setClustredData(availableCurrencies);        
    };


    return(
        <React.Fragment>
            {
                hasCardData() ? <CardsDisplay clustredData={clustredData}/> : null         
            } 
        </React.Fragment>
    )
}
export default CustomerBaseDisplayCards;

const shadowStyle = {
    boxShadow: '1px 2px 3px 1px rgba(0, 0, 0, 0.3)'
};

const CardsDisplay = ({clustredData}) => {

    return(
        <React.Fragment>
            <Col span={7} style={shadowStyle}>
                <CustomerBaseBidCard bidData={clustredData}/>
            </Col>
            <Col span={14} style={shadowStyle}>
                <CustomerBaseChartContainer data={clustredData}/>
            </Col>
        </React.Fragment>
    )
}